import { ChangeLedger } from './ChangeLedger';
import { InstructionComposer } from './InstructionComposer';
import type { NoteInstructionsFooterProps } from './noteInstructions.types';

/** Change ledger + composer, pinned under the SmartPanel tabs (note and Verkefni). */
export const NoteInstructionsFooter = ({
  instructions,
  suggestions,
  disabled,
  notice,
  onSubmit,
  onShowTasks,
}: NoteInstructionsFooterProps) => (
  <div data-testid="note-instructions-footer" className="shrink-0 border-border border-t bg-white px-4 pt-3 pb-2">
    <ChangeLedger
      entries={instructions.entries}
      disabled={instructions.isBusy}
      isUndoable={instructions.isUndoable}
      onUndo={(entryId) => void instructions.undoEntry(entryId)}
      onShowTasks={onShowTasks}
    />
    <InstructionComposer
      suggestions={suggestions}
      isPending={instructions.isPending}
      disabled={disabled || instructions.isBusy}
      notice={notice ?? instructions.reply}
      error={instructions.error}
      onSubmit={onSubmit}
    />
  </div>
);
